"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMobileNodeLabel = generateMobileNodeLabel;
const generateNodeLabel_1 = require("./generateNodeLabel");
const SENTINELS = new Set(['no pane title', 'null', 'undefined']);
/**
 * Normalize + junk-filter a raw candidate. Returns undefined when the value is
 * empty, a sentinel, numeric-only, or hash/UUID-like. Lowercases, collapses
 * whitespace, strips HTML metacharacters/control chars, and trims surrounding
 * punctuation.
 */
function sanitizeMobileValue(value) {
    if (!value) {
        return undefined;
    }
    const cleaned = value
        .replace(/[<>"']/g, '')
        // eslint-disable-next-line no-control-regex
        .replace(/[\x00-\x1F\x7F]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        // Strip any run of non-letter/non-number chars from the start or end.
        // Done before the junk checks so punctuation-clad sentinels/numbers
        // (e.g. "null.", "42:") don't slip past them.
        .replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '');
    if (!cleaned || SENTINELS.has(cleaned)) {
        return undefined;
    }
    if (/^\d+$/.test(cleaned) || /^[0-9a-f-]{16,}$/i.test(cleaned)) {
        return undefined;
    }
    return cleaned;
}
function pickType(types) {
    for (const candidate of types) {
        const sanitized = sanitizeMobileValue(candidate);
        if (sanitized) {
            return sanitized;
        }
    }
    return 'element';
}
/** Build `{type}#{resource_id}`; on overflow truncate the resource id, never the type. */
function buildPrefix(type, resourceId) {
    if (!resourceId) {
        return (0, generateNodeLabel_1.truncate)(type, generateNodeLabel_1.MAX_LENGTH);
    }
    const full = `${type}#${resourceId}`;
    if (full.length <= generateNodeLabel_1.MAX_LENGTH) {
        return full;
    }
    const room = generateNodeLabel_1.MAX_LENGTH - type.length - 1; // reserve one char for '#'
    if (room <= 0) {
        return (0, generateNodeLabel_1.truncate)(type, generateNodeLabel_1.MAX_LENGTH);
    }
    return `${type}#${(0, generateNodeLabel_1.truncate)(resourceId, room)}`;
}
function pickLabel(labels) {
    for (const candidate of labels) {
        const sanitized = sanitizeMobileValue(candidate);
        if (sanitized) {
            return sanitized;
        }
    }
    return undefined;
}
function generateMobileNodeLabel(input) {
    const type = pickType(input.types);
    const resourceId = sanitizeMobileValue(input.resourceId);
    const prefix = resourceId ? `${type}#${resourceId}` : type;
    const chosen = pickLabel(input.labels);
    const separator = ' · ';
    const budget = generateNodeLabel_1.MAX_LENGTH - prefix.length - separator.length;
    if (!chosen || budget <= 0) {
        return buildPrefix(type, resourceId);
    }
    return `${prefix}${separator}${(0, generateNodeLabel_1.truncate)(chosen, budget)}`;
}
//# sourceMappingURL=generateMobileNodeLabel.js.map